
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M323 242c-74.438 0-135 60.563-135 135s60.563 135 135 135 135-60.563 135-135-60.563-135-135-135zm0 230c-52.383 0-95-42.617-95-95s42.617-95 95-95 95 42.617 95 95-42.617 95-95 95zm60-95c0 11.047-8.953 20-20 20h-20v20c0 11.047-8.953 20-20 20s-20-8.953-20-20v-20h-20c-11.047 0-20-8.953-20-20s8.953-20 20-20h20v-20c0-11.047 8.953-20 20-20s20 8.953 20 20v20h20c11.047 0 20 8.953 20 20zM180 492c0 11.047-8.953 20-20 20H80c-44.113 0-80-35.887-80-80V144.855c0-20.765 8.05-40.32 22.668-55.066l66.043-66.633C103.297 8.441 123.547 0 144.27 0h181.62c44.11 0 80 35.887 80 80v106c0 11.047-8.956 20-20 20-11.046 0-20-8.953-20-20V80c0-22.055-17.945-40-40-40H144.27c-10.125 0-20.024 4.125-27.149 11.316l-66.043 66.63c-3.23 3.257-5.797 7-7.644 11.054H99c16.543 0 30-13.46 30-30 0-11.047 8.953-20 20-20s20 8.953 20 20c0 38.598-31.402 70-70 70H40v263c0 22.055 17.945 40 40 40h80c11.047 0 20 8.953 20 20zm0 0","fill":"gray","data-original":"#000000"}})])
          )
        }
      }
    